// Return an expected series description (ie: "Prius Two", "Prius Three", "Camry LE", "Camry Hybrid LE").
// accounts for when a grade may already contain the entire description. (ie: "Prius Two")
define('lib/util/sanity/toSeriesDescription',[], function() {

  return function toSeriesDescription(series, grade){
    if(grade.indexOf(series) >= 0){
      return grade;
    } else {
      return series + ' ' + grade;
    }
  };

});

